<template>
  <div class="question-ruler">
    <div class="text" @click="bindClick" :style="{ color: theme.btnColor }">
      <span class="number">{{ data.value || NowNum }}</span
      ><span class="unit">{{ data.unit }}</span>
    </div>
    <AppRuler
      style="margin-bottom: 48px"
      @change="bindConfirm"
      :NowNum="NowNum"
      :maxNum="data.max_num"
      :minNum="data.min_num"
      :theme="theme.btnColor"
    />
  </div>
</template>
<script>
import AppRuler from '@/components/app/ruler/ruler.vue'
export default {
  components: {
    AppRuler
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showRuler: false,
      NowNum: 0
    }
  },
  computed: {
    id() {
      return this.data.id
    }
  },
  watch: {
    id(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.data.value === '') {
        this.NowNum = this.data.default_value
      } else {
        this.NowNum = +this.data.value
      }
    },
    bindClick() {
      this.showRuler = true
    },
    bindConfirm(value) {
      this.$emit('change', value)
      this.data.value = value + ''
    }
  }
}
</script>
<style lang="scss" scoped>
.question-ruler {
  .text {
    color: #6236ff;
    height: 40px;
    text-align: center;
    margin-bottom: 10px;
  }

  .number {
    font-size: 32px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    line-height: 37px;
    letter-spacing: 1px;
    margin-right: 10px;
  }

  .unit {
    font-size: 14px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    line-height: 16px;
  }
}
</style>
